// export const nftAbi = [
//   {
//     type: "constructor",
//     inputs: [
//       {
//         type: "string",
//         name: "baseURI",
//         internalType: "string",
//       },
//       {
//         type: "address",
//         name: "_receiver",
//         internalType: "address",
//       },
//       {
//         type: "uint8",
//         name: "royaltyFeePercentage",
//         internalType: "uint8",
//       },
//       {
//         type: "uint256",
//         name: "totalNFTs",
//         internalType: "uint256",
//       },
//       {
//         type: "address",
//         name: "initialToken",
//         internalType: "address",
//       },
//     ],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "event",
//     name: "Approval",
//     inputs: [
//       {
//         type: "address",
//         name: "owner",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "approved",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "tokenId",
//         indexed: true,
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "ApprovalForAll",
//     inputs: [
//       {
//         type: "address",
//         name: "owner",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "operator",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "bool",
//         name: "approved",
//         indexed: false,
//         internalType: "bool",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "NFTMinted",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         indexed: true,
//         internalType: "uint256",
//       },
//       {
//         type: "address",
//         name: "to",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "salePrice",
//         indexed: false,
//         internalType: "uint256",
//       },
//     ],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "OwnershipTransferred",
//     inputs: [
//       {
//         type: "address",
//         name: "previousOwner",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "newOwner",
//         indexed: true,
//         internalType: "address",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "Transfer",
//     inputs: [
//       {
//         type: "address",
//         name: "from",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "to",
//         indexed: true,
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "tokenId",
//         indexed: true,
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "AddressRemovedFromWhitelist",
//     inputs: [
//       {
//         type: "address",
//         name: "wallet",
//         internalType: "address",
//         indexed: true,
//       },
//     ],
//   },
//   {
//     type: "event",
//     name: "TokenAccepted",
//     inputs: [
//       {
//         type: "address",
//         name: "token",
//         indexed: true,
//         internalType: "address",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "TokenPriceUpdated",
//     inputs: [
//       {
//         type: "uint256",
//         name: "newTokenPrice",
//         indexed: false,
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "TokenRemoved",
//     inputs: [
//       {
//         type: "address",
//         name: "token",
//         indexed: true,
//         internalType: "address",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },
//   {
//     type: "event",
//     name: "WhitelistToggled",
//     inputs: [
//       {
//         type: "bool",
//         name: "enabled",
//         indexed: false,
//         internalType: "bool",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },   
//   {
//     type: "event",
//     name: "NFTMintedFree",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         indexed: false,
//         internalType: "uint256",
//       },
//       {
//         type: "address",
//         name: "to",
//         indexed: false,
//         internalType: "address",
//       },
//     ],
//     outputs: [],
//     anonymous: false,
//   },  
//   {
//     type: "function",
//     name: "_paused",
//     inputs: [],
//     outputs: [
//       {
//         type: "bool",
//         name: "",
//         internalType: "bool",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "_price",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "approve",
//     inputs: [
//       {
//         type: "address",
//         name: "to",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "balanceOf",
//     inputs: [
//       {
//         type: "address",
//         name: "owner",
//         internalType: "address",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getApproved",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getBaseURI",
//     inputs: [],
//     outputs: [
//       {
//         type: "string",
//         name: "",
//         internalType: "string",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getMintTimestamp",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getMintingInfo",
//     inputs: [
//       {
//         type: "address",
//         name: "wallet",
//         internalType: "address",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256[]",
//         name: "mintedTokens",
//         internalType: "uint256[]",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getPrice",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getTotalMinted",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getTotalNFTs",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "isApprovedForAll",
//     inputs: [
//       {
//         type: "address",
//         name: "owner",
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "operator",
//         internalType: "address",
//       },
//     ],
//     outputs: [
//       {
//         type: "bool",
//         name: "",
//         internalType: "bool",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "mint",
//     inputs: [
//       {
//         type: "uint256",
//         name: "quantity",
//         internalType: "uint256",
//       },
//       {
//         type: "address",
//         name: "_paymentToken",
//         internalType: "address",
//       }
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },  
//   {
//     type: "function",
//     name: "mintTimestamps",
//     inputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "name",
//     inputs: [],
//     outputs: [
//       {
//         type: "string",
//         name: "",
//         internalType: "string",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "owner",
//     inputs: [],
//     outputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "ownerOf",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "renounceOwnership",
//     inputs: [],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "royaltyFee",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint96",
//         name: "",
//         internalType: "uint96",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "royaltyInfo",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//       {
//         type: "uint256",
//         name: "salePrice",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "royaltyReceiver",
//     inputs: [],
//     outputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "safeTransferFrom",
//     inputs: [
//       {
//         type: "address",
//         name: "from",
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "to",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "safeTransferFrom",
//     inputs: [
//       {
//         type: "address",
//         name: "from",
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "to",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//       {
//         type: "bytes",
//         name: "data",
//         internalType: "bytes",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setApprovalForAll",
//     inputs: [
//       {
//         type: "address",
//         name: "operator",
//         internalType: "address",
//       },
//       {
//         type: "bool",
//         name: "approved",
//         internalType: "bool",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setPaused",
//     inputs: [
//       {
//         type: "bool",
//         name: "val",
//         internalType: "bool",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setPrice",
//     inputs: [
//       {
//         type: "uint256",
//         name: "newPrice",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setRoyaltyFee",
//     inputs: [
//       {
//         type: "uint96",
//         name: "_royaltyFee",
//         internalType: "uint96",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setRoyaltyReceiver",
//     inputs: [
//       {
//         type: "address",
//         name: "_royaltyReceiver",
//         internalType: "address",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setTotalNFTs",
//     inputs: [
//       {
//         type: "uint256",
//         name: "totalNFTs",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "supportsInterface",
//     inputs: [
//       {
//         type: "bytes4",
//         name: "interfaceId",
//         internalType: "bytes4",
//       },
//     ],
//     outputs: [
//       {
//         type: "bool",
//         name: "",
//         internalType: "bool",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "symbol",
//     inputs: [],
//     outputs: [
//       {
//         type: "string",
//         name: "",
//         internalType: "string",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "tokenByIndex",
//     inputs: [
//       {
//         type: "uint256",
//         name: "index",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "tokenIds",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "tokenOfOwnerByIndex",
//     inputs: [
//       {
//         type: "address",
//         name: "owner",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "index",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "tokenURI",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [
//       {
//         type: "string",
//         name: "",
//         internalType: "string",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "totalSupply",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "transferFrom",
//     inputs: [
//       {
//         type: "address",
//         name: "from",
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "to",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "transferOwnership",
//     inputs: [
//       {
//         type: "address",
//         name: "newOwner",
//         internalType: "address",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "whitelistMints",
//     inputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "whitelistEnabled",
//     inputs: [],
//     outputs: [
//       {
//         type: "bool",
//         name: "",
//         internalType: "bool",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "whitelist",
//     inputs: [
//       {
//         type: "address",
//         name: "",
//         internalType: "address",
//       },
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "isWhitelistEnabled",
//     inputs: [],
//     outputs: [
//       {
//         type: "bool",
//         name: "",
//         internalType: "bool",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "getAllWhitelistedAddresses",
//     inputs: [],
//     outputs: [
//       {
//         type: "address[]",
//         name: "",
//         internalType: "address[]",
//       },
//       {
//         type: "uint256[]",
//         name: "",
//         internalType: "uint256[]",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "toggleWhitelist",
//     inputs: [
//       {
//         type: "bool",
//         name: "enabled",
//         internalType: "bool",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "removeFromWhiteList",
//     inputs: [
//       {
//         type: "address[]",
//         name: "wallets",
//         internalType: "address[]",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "freeMint",
//     inputs: [
//       {
//         type: "uint256",
//         name: "quantity",
//         internalType: "uint256",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "addToWhiteList",
//     inputs: [
//       {
//         type: "address[]",
//         name: "wallets",
//         internalType: "address[]",
//       },
//       {
//         type: "uint256[]",
//         name: "limits",
//         internalType: "uint256[]",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setTokenURI",
//     inputs: [
//       {
//         type: "uint256",
//         name: "tokenId",
//         internalType: "uint256",
//       },
//       {
//         type: "string",
//         name: "newTokenURI",
//         internalType: "string",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "setBaseURI",
//     inputs: [
//       {
//         type: "string",
//         name: "newBaseURI",
//         internalType: "string",
//       },
//     ],
//     outputs: [],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "_tokenPrice",
//     inputs: [],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       },
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "approve",
//     inputs: [
//       {
//         type: "address",
//         name: "spender",
//         internalType: "address",
//       },
//       {
//         type: "uint256",
//         name: "amount",
//         internalType: "uint256",
//       }
//     ],
//     outputs: [
//       {
//         type: "bool",
//         name: "",
//         internalType: "bool",
//       }
//     ],
//     stateMutability: "nonpayable",
//   },
//   {
//     type: "function",
//     name: "allowance",
//     inputs: [
//       {
//         type: "address",
//         name: "owner",
//         internalType: "address",
//       },
//       {
//         type: "address",
//         name: "spender",
//         internalType: "address",
//       }
//     ],
//     outputs: [
//       {
//         type: "uint256",
//         name: "",
//         internalType: "uint256",
//       }
//     ],
//     stateMutability: "view",
//   },
//   {
//     type: "function",
//     name: "decimals",
//     inputs: [],
//     outputs: [
//         {
//             type: "uint8",
//             name: "",
//             internalType: "uint8"
//         }
//     ],
//     stateMutability: "view"
//   },
// ];

export const marketplaceAbi = [
  {
    type: "constructor",
    name: "",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "error",
    name: "CallerIsNotListingOwner",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "CallerIsNotOwner",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "ConsiderationExpired",
    inputs: [
      {
        type: "uint256",
        name: "timeExpired",
        internalType: "uint256",
      },
    ],
    outputs: [],
  },
  {
    type: "error",
    name: "ConsiderationNotInRange",
    inputs: [
      {
        type: "uint256",
        name: "minimumConsideration",
        internalType: "uint256",
      },
    ],
    outputs: [],
  },
  {
    type: "error",
    name: "ExpiryTimeNotInFuture",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "IncorrectValueProvided",
    inputs: [
      {
        type: "uint256",
        name: "listingPrice",
        internalType: "uint256",
      },
    ],
    outputs: [],
  },
  {
    type: "error",
    name: "IndexOutOfBounds",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "PurchaserIsOwner",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "TokenAlreadyListed",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "TokenNotFound",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "UnauthorizedTransfer",
    inputs: [],
    outputs: [],
  },
  {
    type: "error",
    name: "UnsupportedToken",
    inputs: [],
    outputs: [],
  },
  {
    type: "event",
    name: "ListingCreated",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "price",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "expires",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "address",
        name: "owner",
        indexed: true,
        internalType: "address",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "ListingExpired",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "ListingFulfilled",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "consideration",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "marketFee",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "creatorFee",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "address",
        name: "seller",
        indexed: false,
        internalType: "address",
      },
      {
        type: "address",
        name: "purchaser",
        indexed: true,
        internalType: "address",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "ListingRevoked",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "MarketplaceFeeUpdated",
    inputs: [
      {
        type: "uint256",
        name: "newFee",
        indexed: false,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "MinimumConsiderationUpdated",
    inputs: [
      {
        type: "uint256",
        name: "previous",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "consideration",
        indexed: false,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "OfferAccepted",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "offerIndex",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "consideration",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "marketFee",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "creatorFee",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "address",
        name: "seller",
        indexed: false,
        internalType: "address",
      },
      {
        type: "address",
        name: "purchaser",
        indexed: true,
        internalType: "address",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "OfferCreated",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "offerIndex",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "price",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "expires",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "address",
        name: "creator",
        indexed: true,
        internalType: "address",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "OfferRevoked",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: true,
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        indexed: true,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "offerIndex",
        indexed: true,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        type: "address",
        name: "previousOwner",
        indexed: true,
        internalType: "address",
      },
      {
        type: "address",
        name: "newOwner",
        indexed: true,
        internalType: "address",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoyaltyFeeUpdated",
    inputs: [
      {
        type: "uint256",
        name: "numerator",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "denominator",
        indexed: false,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoyaltyPercentageUpdated",
    inputs: [
      {
        type: "uint256",
        name: "num",
        indexed: false,
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "den",
        indexed: false,
        internalType: "uint256",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoyaltyReceiverUpdated",
    inputs: [
      {
        type: "address",
        name: "receiver",
        indexed: true,
        internalType: "address",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "SupportedTokenUpdated",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: false,
        internalType: "address",
      },
      {
        type: "bool",
        name: "isSupported",
        indexed: false,
        internalType: "bool",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "SupportedTokenUpdated",
    inputs: [
      {
        type: "address",
        name: "token",
        indexed: false,
        internalType: "contract IERC721",
      },
      {
        type: "bool",
        name: "supported",
        indexed: false,
        internalType: "bool",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "TokenRestrictionsUpdated",
    inputs: [
      {
        type: "bool",
        name: "restricted",
        indexed: false,
        internalType: "bool",
      },
    ],
    outputs: [],
    anonymous: false,
  },
  {
    type: "function",
    name: "acceptOffer",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "offerIndex",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "allListings",
    inputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "timeListed",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "timeExpires",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "price",
        internalType: "uint256",
      },
      {
        type: "address",
        name: "nftAddress",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "itemId",
        internalType: "uint256",
      },
      {
        type: "address",
        name: "currentOwner",
        internalType: "address",
      },
      {
        type: "bool",
        name: "listed",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "createListing",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "price",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "expires",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "createOffer",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "expires",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "directListing",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "getAllListedNFTs",
    inputs: [],
    outputs: [
      {
        type: "tuple[]",
        name: "",
        components: [
          {
            type: "address",
            name: "owner",
            internalType: "address",
          },
          {
            type: "uint256",
            name: "tokenId",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "timeListed",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "timeExpires",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "price",
            internalType: "uint256",
          },
          {
            type: "address",
            name: "nftAddress",
            internalType: "address",
          },
          {
            type: "uint256",
            name: "itemId",
            internalType: "uint256",
          },
          {
            type: "address",
            name: "currentOwner",
            internalType: "address",
          },
          {
            type: "bool",
            name: "listed",
            internalType: "bool",
          },
        ],
        internalType: "struct MetaXIMarketplace.MarketplaceItemListing[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getCurrentOffers",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "tuple[]",
        name: "",
        components: [
          {
            type: "address",
            name: "offerer",
            internalType: "address",
          },
          {
            type: "uint256",
            name: "tokenId",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "timeOffered",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "timeExpires",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "amount",
            internalType: "uint256",
          },
        ],
        internalType: "struct MetaXIMarketplace.MarketplaceItemOffer[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getNFTsListedByAddress",
    inputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
      },
    ],
    outputs: [
      {
        type: "tuple[]",
        name: "",
        components: [
          {
            type: "address",
            name: "owner",
            internalType: "address",
          },
          {
            type: "uint256",
            name: "tokenId",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "timeListed",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "timeExpires",
            internalType: "uint256",
          },
          {
            type: "uint256",
            name: "price",
            internalType: "uint256",
          },
          {
            type: "address",
            name: "nftAddress",
            internalType: "address",
          },
          {
            type: "uint256",
            name: "itemId",
            internalType: "uint256",
          },
          {
            type: "address",
            name: "currentOwner",
            internalType: "address",
          },
          {
            type: "bool",
            name: "listed",
            internalType: "bool",
          },
        ],
        internalType: "struct MetaXIMarketplace.MarketplaceItemListing[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getOwnedTokenIds",
    inputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
      },
    ],
    outputs: [
      {
        type: "uint256[]",
        name: "",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getTokenIdsAndContractAddresses",
    inputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
      },
    ],
    outputs: [
      {
        type: "uint256[]",
        name: "",
        internalType: "uint256[]",
      },
      {
        type: "address[]",
        name: "",
        internalType: "address[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "marketplaceFee",
    inputs: [],
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "onERC721Received",
    inputs: [
      {
        type: "address",
        name: "operator",
        internalType: "address",
      },
      {
        type: "address",
        name: "from",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "bytes",
        name: "data",
        internalType: "bytes",
      },
    ],
    outputs: [
      {
        type: "bytes4",
        name: "",
        internalType: "bytes4",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "ownerTokenIds",
    inputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "restrictTokens",
    inputs: [],
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "revokeListing",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "revokeOffer",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "offerIndex",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "royaltyFee",
    inputs: [],
    outputs: [
      {
        type: "uint256",
        name: "numerator",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "denominator",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "royaltyReceiver",
    inputs: [],
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "setRoyaltyFee",
    inputs: [
      {
        type: "uint256",
        name: "_numerator",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "_denominator",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setRoyaltyReceiver",
    inputs: [
      {
        type: "address",
        name: "receiver",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "supportedTokenList",
    inputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IERC721",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "supportedTokens",
    inputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IERC721",
      },
    ],
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "supportedTokensArray",
    inputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IERC721",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "toggleSupportedToken",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "tokenListings",
    inputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "timeListed",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "timeExpires",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "price",
        internalType: "uint256",
      },
      {
        type: "address",
        name: "nftAddress",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "itemId",
        internalType: "uint256",
      },
      {
        type: "address",
        name: "currentOwner",
        internalType: "address",
      },
      {
        type: "bool",
        name: "listed",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "tokenOffers",
    inputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "address",
        name: "offerer",
        internalType: "address",
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "timeOffered",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "timeExpires",
        internalType: "uint256",
      },
      {
        type: "uint256",
        name: "amount",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        type: "address",
        name: "newOwner",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "updateMarketplaceFee",
    inputs: [
      {
        type: "uint256",
        name: "newFee",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "viewCreatorFee",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "contract IERC721",
      },
      {
        type: "uint256",
        name: "transactionValue",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        type: "uint256",
        name: "",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
];
